import { useContext } from 'react';

import { PermissionsContext } from '../../context/permissions/permissionsContext/PermissionsContext';
import { PermissionsContextValue } from '../../context/permissions/permissionsContextController/PermissionsContext.types';

export const usePermissions = (): PermissionsContextValue => {
  const context = useContext(PermissionsContext);

  if (!context) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }

  return context;
};
